export default {
  "hierarchy": {
    "bottom": [
      "tabPane-bottom"
    ],
    "mobileDetailViewTabs": [
      "tabPane-mobileDetailViewTabs"
    ],
    "detailViewTabs": [
      "tabPane-detailViewTabs"
    ],
    "settingsTabs": [
      "tabPane-detailViewTabs",
      "tabPane-settingsTabs"
    ],
    "tempUser": [
      "tabPane-tempUser"
    ]
  },
  "props": {
    "default": {},
    "bottom": {},
    "mobileDetailViewTabs": {},
    "detailViewTabs": {},
    "settingsTabs": {},
    "tempUser": {}
  }
}